export const feelingDefault = [
  'Glad',
  'Pigg',
  'Trygg',
  'Lugn',
  'Orolig',
  'Trött',
  'Omotiverad',
  'Stressad',
  'Ledsen',
  'Rädd',
  'Arg',
  'Neutral (t ex vid sömn)',
  'Annat',
];
